module.exports = __webpack_public_path__ + "img/preview1.1b2cba29.png";